import { createContext, PropsWithChildren, useContext } from "react";

export type Config = {
    readonly environment: ConfigEnvironment;
    readonly version: string;
    readonly trelloClientBaseUrl: string; // TODO: trello specific - move to trello blueprint
    readonly skipAnalytics?: boolean;
};

export type ConfigEnvironment = "development" | "staging" | "production";

export function useConfig(): Config {
    return useContext(ConfigContext);
}

export type ConfigProviderProps = {
    readonly config?: Partial<Config>;
};

export const ConfigProvider = ({
    config = {},
    children
}: PropsWithChildren<ConfigProviderProps>) => {
    return (
        <ConfigContext.Provider
            value={{
                ...DEFAULT_CONFIG,
                ...config
            }}
        >
            {children}
        </ConfigContext.Provider>
    );
};

export const CONFIG_ID_ATTRIBUTE = "BXP_CONFIG";

const DEFAULT_CONFIG: Config = {
    environment: "development",
    version: "n/a",
    trelloClientBaseUrl: ""
};

const ConfigContext = createContext(DEFAULT_CONFIG);
